// html-decode.pipe.ts

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlDecode',
  standalone: true
})

export class HtmlDecodePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value)
        return '';

    const textarea = document.createElement('textarea');

    // El texto puede venir doblemente codificado (p. ej. "&amp;oacute;" → "&oacute;" → "ó").
    // Decodificamos repetidamente hasta que el resultado deje de cambiar.
    let decoded = value;
    for (let i = 0; i < 5; i++) {
        textarea.innerHTML = decoded;
        const next = textarea.value;
        if (next === decoded) {
            break;
        }
        decoded = next;
    }

    return decoded;
  }
}